/* ============================================================
   La Nani — evenimente catre Meta, cu ID-ul din catalog

   De ce exista:

   EasySell trimite AddToCart cu content_ids ca numar simplu
   (15860516487551) si content_type "product_group". Meta cere un
   array de string-uri, iar pentru articole cere "product", nu
   "product_group". Din ambele motive evenimentul lor nu se leaga
   corect de catalog.

   Aici il trimitem noi, corect:
     content_ids  = [id numeric]    id-ul de produs Shopify, luat din
                                    data-ln-handle (= {{ product.id }}).
                                    Masurat: e exact acelasi id pe care
                                    il trimite si EasySell, deci
                                    evenimentele noastre si ale lor sunt
                                    consistente intre ele.
     content_type = "product"       articol, nu grup de articole

   NEVERIFICAT: daca in Commerce Manager catalogul e cheiat chiar pe
   id-ul asta. Nu avem acces acolo. O varianta veche a acestui
   comentariu sustinea ca acolo e handle-ul produsului — nu e dovedit
   nicaieri, si codul a trimis dintotdeauna id-ul numeric.

   IMPORTANT: bifa "Track AddToCart Event when add to cart button is
   clicked" din EasySell trebuie DEBIFATA, altfel se trimit doua
   evenimente pentru o singura adaugare.
   ============================================================ */
(function () {
  'use strict';

  /* DE CE nu se poate scoate stratul ăsta, deși EasySell trimite singur
     evenimentele. Din sursa lor:

       const o = window.ES_FB_GROUP !== false;
       content_ids:  o ? d.product_id : d.variant_id
       content_type: o ? "product_group" : "product"

     Cele două merg împreună, și niciuna din combinații nu e bună:
       ES_FB_GROUP nesetat → id de produs (corect) + "product_group" (greșit)
       ES_FB_GROUP = false → "product" (corect) + id de variantă (nu e în catalog)

     Catalogul are id-uri de produs, deci ne trebuie id de produs ȘI
     "product". Stratul de mai jos face exact asta: lasă id-urile lor
     neatinse și rescrie doar tipul. */
  var MONEDA = 'RON';

  /* Cand am trimis noi InitiateCheckout, si daca apelul curent e al nostru.
     Vezi comentariul de la incepeCheckout. */
  var checkoutTrimisLa = 0;
  var alNostru = false;

  function pretNumeric(v) {
    if (typeof v === 'number' && isFinite(v)) return v;
    if (!v) return null;
    var curat = String(v).replace(/[^\d,.]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    var n = parseFloat(curat);
    return isFinite(n) ? n : null;
  }

  /* ---------- coada de siguranta ----------

     Regula, si e cea mai importanta din fisier: un eveniment nu se arunca
     NICIODATA.

     Pixelul nu e in tema, il injecteaza EasySell la runtime. Masurat pe
     live, pe desktop rapid, cu cache cald:
        ~525-571 ms   butonul de comanda e deja apasabil
        ~743-983 ms   abia acum apare window.fbq (ciotul din snippet)
       ~1384-1435 ms  fbevents.js descarcat
       ~1700-2000 ms  callMethod pus, stratul de mai jos se instaleaza
     Deci o secunda pana la o secunda si jumatate in care omul poate apasa
     iar pixelul nu e gata. Pe date mobile, cu DNS si TLS reci catre
     connect.facebook.net, fereastra e de cateva secunde.

     Varianta veche iesea pur si simplu din functie cand fbq lipsea sau cand
     stratul nu era pus, si evenimentul se pierdea definitiv. Acum il tinem
     in coada si il trimitem in clipa in care se poate.

     Doua feluri de asteptare:
       - AddToCart si ViewContent au nevoie doar de fbq. Merg si prin ciot:
         ciotul are propria coada, pe care fbevents o goleste cand se incarca.
       - InitiateCheckout are nevoie de STRAT, pentru ca doar stratul stie
         sa-l inabuse pe cel trimis de EasySell. Daca stratul intarzie peste
         PRAG_STRAT, il trimitem oricum: o dublura rara se vede in Events
         Manager si se corecteaza, un eveniment pierdut nu se mai
         recupereaza niciodata. */
  var PRAG_STRAT = 8000;    /* cat asteptam stratul inainte sa trimitem oricum */
  var PAS_COADA = 100;      /* cat de des reincercam */
  var RABDARE_COADA = 600;  /* de cate ori; 600 x 100 ms = un minut */

  var coada = [];
  var ceas = 0;
  var incercariCoada = 0;

  function pune(nume, date, cereStrat) {
    coada.push({ nume: nume, date: date, strat: !!cereStrat, cand: Date.now() });
    goleste();
  }

  function goleste() {
    var ramase = [];
    for (var i = 0; i < coada.length; i++) {
      var e = coada[i];
      var arePixel = typeof window.fbq === 'function';
      var poate = arePixel &&
        (!e.strat || !!window.fbq.lnStrat || Date.now() - e.cand >= PRAG_STRAT);
      if (!poate) { ramase.push(e); continue; }
      /* alNostru il opreste pe strat sa inabuse chiar evenimentul nostru */
      if (e.strat) alNostru = true;
      try { window.fbq('track', e.nume, e.date); } catch (er) {}
      alNostru = false;
    }
    coada = ramase;

    if (!coada.length) {
      if (ceas) { clearInterval(ceas); ceas = 0; }
      incercariCoada = 0;
      return;
    }
    if (ceas) return;
    incercariCoada = 0;
    ceas = setInterval(function () {
      /* Daca pixelul nu apare intr-un minut, e blocat de o extensie sau de
         retea. Oprim ceasul ca sa nu tinem telefonul treaz degeaba, dar NU
         aruncam evenimentele: raman in coada si pleaca daca mai vine ceva
         care porneste ceasul din nou. */
      if (++incercariCoada > RABDARE_COADA) { clearInterval(ceas); ceas = 0; return; }
      goleste();
    }, PAS_COADA);
  }

  window.lnMeta = {
    adaugaInCos: function (date) {
      if (!date || !date.handle) return;

      var cate = date.cantitate || 1;
      var pret = pretNumeric(date.pret);

      var payload = {
        content_type: 'product',
        content_ids: [String(date.handle)],
        contents: [{ id: String(date.handle), quantity: cate }],
        currency: MONEDA
      };
      if (date.nume) payload.content_name = date.nume;
      if (pret !== null) payload.value = +(pret * cate).toFixed(2);

      pune('AddToCart', payload, false);
    },

    /* ViewContent pe pagina de produs.
       Verificat pe live: la incarcare pixelul ajunge la eventCount 2, adica
       PageView plus asta. EasySell are bifa de ViewContent oprita, deci nu
       se dubleaza nimic. */
    vedeProdus: function (date) {
      if (!date || !date.id) return;

      var pret = pretNumeric(date.pret);
      var payload = {
        content_type: 'product',
        content_ids: [String(date.id)],
        contents: [{ id: String(date.id), quantity: 1 }],
        currency: MONEDA
      };
      if (date.nume) payload.content_name = date.nume;
      if (pret !== null) payload.value = +pret.toFixed(2);

      pune('ViewContent', payload, false);
    },

    /* ---------- InitiateCheckout, trimis de noi ----------

       De ce nu-l lasam pe EasySell sa-l trimita, desi el il trimite.
       Din sursa lor:

         popupListner(){ Be(); await this.updateCart(); this.trackInitiateCheckout(); }

       Adica deschid modalul, apoi asteapta mai multe cereri de retea, si
       abia dupa aceea trimit evenimentul — si doar daca formDisabled este
       false. Daca o cerere cade sau atarna, evenimentul lor nu pleaca
       niciodata. S-a si intamplat: un om a completat tot formularul si in
       Meta n-a aparut niciun checkout.

       Deci il trimitem noi, cu formatul si valoarea corecte.

       CAND il trimitem: exact atunci cand formularul se deschide pe ecran.
       Decizia proprietarului, si e corecta — evenimentul trebuie sa fie un
       semnal de sanatate pentru formular. Daca oamenii apasa butonul si in
       Meta nu mai vin checkout-uri, se vede imediat ca formularul nu se mai
       deschide. Daca ar pleca la apasare, semnalul asta s-ar pierde.
       Momentul e ales in assets/la-nani-easysell.js, in
       `trimiteCandSeDeschide`.

       Ca sa nu iasa doua evenimente, stratul de mai jos il inabusa pe al lor
       daca vine in 12 secunde dupa al nostru. */
    incepeCheckout: function (date) {
      if (!date || !date.ids || !date.ids.length) return;

      /* acelasi buton apasat de doua ori nu inseamna doua comenzi */
      if (checkoutTrimisLa && Date.now() - checkoutTrimisLa < 12000) return;

      var cant = date.cantitati || [];
      var payload = {
        content_type: 'product',
        content_ids: date.ids.map(function (x) { return String(x); }),
        contents: date.ids.map(function (x, i) {
          return { id: String(x), quantity: cant[i] || 1 };
        }),
        currency: MONEDA
      };
      var v = pretNumeric(date.valoare);
      if (v !== null) payload.value = +v.toFixed(2);
      if (date.bucati) payload.num_items = date.bucati;

      /* Marcajul de timp e al CLICKULUI, nu al trimiterii. Daca evenimentul
         asteapta in coada, inabusirea dublurii de la EasySell ramane
         ancorata in momentul in care omul a apasat. */
      checkoutTrimisLa = Date.now();
      pune('InitiateCheckout', payload, true);
    }
  };

  /* Declansare automata pe pagina de produs, o singura data.
     Nu mai asteptam pixelul aici: coada de mai sus se ocupa de asta. */
  function laProdus() {
    var r = document.querySelector('[data-ln-pdp]');
    if (!r || r.dataset.lnViewTrimis) return;

    r.dataset.lnViewTrimis = '1';
    window.lnMeta.vedeProdus({
      id: r.getAttribute('data-ln-varianta') || r.getAttribute('data-ln-handle'),
      nume: r.getAttribute('data-ln-nume'),
      pret: parseFloat(r.getAttribute('data-ln-pret'))
    });
  }

    /* ---------- curatam evenimentele trimise de altii ----------

     NU RESCRIE `content_type` AICI. S-a incercat, de doua ori, si nu a mers.

     Ce trimite EasySell, confirmat de echipa lor tehnica:
         product_group => ID de PRODUS
         product       => ID de VARIANTA

     Catalogul magazinului e construit standard, ca orice catalog Shopify:
         articol (id)         = ID de VARIANTA
         grup (item_group_id) = ID de PRODUS

     Deci evenimentul lor, asa cum vine, e deja corect: numar de produs cu
     eticheta de grup. Meta gaseste grupul, iar grupul e produsul.

     Istoric, ca sa nu se mai piarda nimeni aici:
       - pana la 1 sep: catalog pe PRODUSE, fara rescriere -> nu s-a atribuit
         niciodata pe produs
       - 1-4 sep: catalog pe PRODUSE, cu rescriere in "product" -> tot nu
       - 4 sep: catalog pe VARIANTE, fara rescriere -> asta e varianta
         standard, singura netestata pana acum

     Aici ramane doar transformarea numerelor in text, ceruta de Meta.

function indreapta(d) {
    if (!d || typeof d !== 'object') return d;
    var o = {};
    for (var k in d) if (Object.prototype.hasOwnProperty.call(d, k)) o[k] = d[k];
    if (o.content_ids !== null && o.content_ids !== undefined) {
      var lista = Array.isArray(o.content_ids) ? o.content_ids : [o.content_ids];
      o.content_ids = lista.map(function (x) { return String(x); });
    }
    if (Array.isArray(o.contents)) {
      o.contents = o.contents.map(function (c) {
        if (!c || typeof c !== 'object') return c;
        var n = {};
        for (var j in c) if (Object.prototype.hasOwnProperty.call(c, j)) n[j] = c[j];
        if (n.id !== null && n.id !== undefined) n.id = String(n.id);
        return n;
      });
    }
    return o;
  }

  /* fbq se incarca asincron: asteptam sa apara. */
  /* ATENTIE la conditia de mai jos, a costat comenzi.

     O varianta si mai veche ambala fbq de indata ce era o functie. Dar si
     ciotul din snippetul Meta e o functie, cu mult inainte ca fbevents.js
     sa se incarce:

       n = f.fbq = function(){ n.callMethod ? n.callMethod.apply(n, arguments)
                                            : n.queue.push(arguments) }

     Ciotul se refera la el insusi prin n. Daca punem stratul peste el si
     inlocuim window.fbq, biblioteca reala se incarca dupa aceea si isi pune
     callMethod pe STRATUL nostru, nu pe ciot. Iar stratul deleaga inapoi la
     ciot, care se uita la propriul n.callMethod, il gaseste gol, si impinge
     evenimentul intr-o coada pe care n-o mai goleste nimeni.

     Rezultat: se pierdeau TOATE evenimentele, in tacere.

     Masurat cu un pixel fals, pe varianta fara conditia de mai jos:
       pixelul incarcat primul   -> 2 evenimente ajung, 0 blocate
       scriptul nostru primul    -> 0 evenimente ajung, 2 blocate
     Cu conditia pusa, ambele ordini dau 2 din 2 si 0 blocate.

     Deci asteptam callMethod, care apare abia cand biblioteca reala s-a
     atasat. Atunci ciotul il are pe el insusi si delegarea merge mereu.

     Daca pixelul nu se incarca niciodata (blocat de o extensie), nu ambalam
     nimic si evenimentele merg pe drumul lor normal, ca si cum n-am fi aici. */
  function imbraca(incercari) {
    if (typeof window.fbq !== 'function' || typeof window.fbq.callMethod !== 'function') {
      incercari = (incercari || 0) + 1;
      if (incercari <= 300) setTimeout(function () { imbraca(incercari); }, 100);
      return;
    }
    if (window.fbq.lnStrat) return;

    var dedesubt = window.fbq;
    var strat = function () {
      var a = Array.prototype.slice.call(arguments);
      try {
        /* Un singur InitiateCheckout, oricare ar veni primul.

           Cat timp il trimiteam noi la apasare, al nostru era mereu primul
           si il inabuseam pe al lor. Acum il trimitem cand se deschide
           formularul, deci ne putem trezi ca al lor ajunge primul (masurat:
           al lor la 663 ms, al nostru la 1003 ms) — si atunci ieseau doua.

           Regula acum: primul castiga. Daca al lor trece primul, il
           indreptam si tinem minte ora, iar `incepeCheckout` nu-l mai
           trimite pe al nostru. Daca al nostru pleaca primul, al lor e
           inabusit ca pana acum. */
        if ((a[0] === 'track' || a[0] === 'trackCustom') && a[1] === 'InitiateCheckout') {
          if (!alNostru && checkoutTrimisLa && Date.now() - checkoutTrimisLa < 12000) return;
          if (!alNostru) checkoutTrimisLa = Date.now();
        }
        if (a[0] === 'track' || a[0] === 'trackCustom') a[2] = indreapta(a[2]);
        else if (a[0] === 'trackSingle' || a[0] === 'trackSingleCustom') a[3] = indreapta(a[3]);
      } catch (e) { a = Array.prototype.slice.call(arguments); }
      return dedesubt.apply(this, a);
    };
    /* pastram proprietatile pixelului (queue, callMethod, loaded, version) */
    for (var k in dedesubt) { try { strat[k] = dedesubt[k]; } catch (e) {} }
    strat.lnStrat = true;
    window.fbq = strat;
    if (window._fbq === dedesubt) window._fbq = strat;

    /* stratul tocmai s-a pus: golim imediat ce astepta dupa el */
    goleste();
  }
  imbraca(0);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { laProdus(); });
  } else {
    laProdus();
  }
  window.addEventListener('load', function () { laProdus(); });
})();
